import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
const SimpleTooltip = ({ id, placement = 'right', tooltip = null, children, }) => {
    if (!tooltip || !children)
        return children;
    const overlay = useMemo(() => _jsx(Tooltip, Object.assign({ id: id }, { children: tooltip })), [id, tooltip]);
    return (_jsx(OverlayTrigger, Object.assign({ placement: placement, overlay: overlay }, { children: children })));
};
export default SimpleTooltip;
